import { Clock } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

export default function Pending() {
  const { user } = useAuth();
  return (
    <div className="mx-auto max-w-md py-20 text-center">
      {/* Pending si drží užší max-width schválně — je to centrovaný message state. */}
      <Clock className="mx-auto mb-4 h-10 w-10 text-gold" />
      <h1 className="mb-2 font-heading text-2xl font-bold text-dark">Čekáš na přidělení přístupu</h1>
      <p className="text-sm text-gray-600">
        {user?.name}, tvůj účet byl vytvořený, ale administrátor ti zatím nepřidělil žádné sekce ani kapitoly.
        Napiš kolegovi ve firmě, ať ti přístupy nastaví.
      </p>
    </div>
  );
}
